import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/wlearn-logo.webp")